<app-layout-row margin="">
    <app-layout-column [width]="11">
        <app-layout-row margin="">
            <app-layout-column [width]="11">
                <app-layout-row margin="">

                    <app-layout-column [width]="3">
                        <app-textbox decorator [ngModel]="filter().PropertyName" name="propertyName" caption="Property name" required (ngModelChange)="onPropertyNameChange($event)" [disabled]="readonly()"></app-textbox>
                    </app-layout-column>

                    <app-layout-column [width]="3">
                        <app-textbox decorator [ngModel]="filter().PropertyNamespace" name="namespace" caption="Namespace" required (ngModelChange)="onPropertyNamespaceChange($event)" [disabled]="readonly()"></app-textbox>
                    </app-layout-column>

                    <app-layout-column [width]="3">
                        <app-singleselectbox decorator name="operatorKey" caption="Condition" [ngModel]="selectedComparerKey" [dataSource]="comparers" valueExpr="key" displayExpr="name" required [disabled]="true">
                        </app-singleselectbox>
                    </app-layout-column>

                    <app-layout-column [width]="3">
                        <app-textbox decorator [ngModel]="filter().Values[0].Value" name="value" caption="Value" required (ngModelChange)="onValueChange(0, $event)" [disabled]="readonly()"></app-textbox>
                    </app-layout-column>
                </app-layout-row>
            </app-layout-column>
            <app-layout-column [width]="1">
                @if (filter().Values.length === 1 && readonly() === false) {
                    <div class="orButton">
                        <app-link iconClass="dx-icon-add" (onClick)="addValue($event)">OR</app-link>
                    </div>
                }
            </app-layout-column>
        </app-layout-row>
    </app-layout-column>
    <app-layout-column [width]="1">
        <div class="conditionButtons">
            @if (readonly() === false) {
                <app-link iconClass="dx-icon-trash" (onClick)="deleteFilter()">Remove</app-link>
            }
        </div>
    </app-layout-column>
</app-layout-row>

@for (value of filter().Values.slice(1); track value.Id; let idx = $index) {
    <fieldset [ngModelGroup]="$safeNavigationMigration(value.Id?.toString())" #form="ngModelGroup">
        <app-layout-row margin="">
            <app-layout-column [width]="11">
                <app-layout-row margin="">
                    <app-layout-column [width]="11">
                        <app-layout-row margin="">
                            <app-layout-column [width]="3" [offset]="6">
                            </app-layout-column>
                            <app-layout-column [width]="3">
                                <app-textbox decorator [ngModel]="filter().Values[idx+1].Value" name="value" caption="Or" required (ngModelChange)="onValueChange(idx+1, $event)" [disabled]="readonly()"></app-textbox>
                            </app-layout-column>
                        </app-layout-row>
                    </app-layout-column>
                    <app-layout-column [width]="1">
                        <div class="orButton">
                            @if (filter().Values.length === idx+2 && readonly() === false) {
                                <app-link iconClass="dx-icon-add" (onClick)="addValue($event)">OR</app-link>
                            }
                        </div>
                    </app-layout-column>
                </app-layout-row>
            </app-layout-column>
            <app-layout-column [width]="1">
                <div class="conditionButtons">
                    @if (readonly() === false) {
                        <app-link iconClass="dx-icon-trash" (onClick)="deleteValue(idx)">Remove</app-link>
                    }
                </div>
            </app-layout-column>
        </app-layout-row>
    </fieldset>
}
